import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

import { ClinicalShell } from '@/components/layouts/ClinicalShell';
import { AUTH_ROUTES } from '@/lib/constants';
import { pickHighestAdminRole, STAFF_ROLES } from '@/lib/rbac';
import { useAuthStore } from '@/stores/authStore';

export const Route = createFileRoute('/app')({
  beforeLoad: () => {
    const { isAuthenticated, user } = useAuthStore.getState();
    if (!isAuthenticated || !user) {
      // eslint-disable-next-line @typescript-eslint/only-throw-error, @typescript-eslint/no-unnecessary-type-assertion -- 'as never' is load-bearing for pnpm build: tsc -b requires a search shape for /login here; the lint-side program flags it as redundant (false positive)
      throw redirect({ to: AUTH_ROUTES.STAFF_LOGIN as never });
    }
    if (user.role === 'org_user') {
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({ to: '/org/portal/dashboard' });
    }
    const admin = pickHighestAdminRole(user.role);
    if (admin === 'super_admin') {
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({ to: '/admin/platform' });
    }
    if (admin === 'ba_super_admin' || admin === 'ba_admin') {
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({ to: '/admin/workspace' });
    }
    const staff = user.role !== null && STAFF_ROLES.includes(user.role);
    if (!staff) {
      // eslint-disable-next-line @typescript-eslint/only-throw-error, @typescript-eslint/no-unnecessary-type-assertion -- 'as never' is load-bearing for pnpm build: tsc -b requires a search shape for /login here; the lint-side program flags it as redundant (false positive)
      throw redirect({ to: AUTH_ROUTES.STAFF_LOGIN as never });
    }
  },
  component: AppLayout,
  staticData: { surface: 'Clinical Workspace' },
});

function AppLayout() {
  return (
    <ClinicalShell>
      <Outlet />
    </ClinicalShell>
  );
}
